import { convertWeiToEth, trimDecimals } from '@pkg/utils';

import { Currency } from '@app/client';
import { getConversion } from '@app/store/zustand/exchange-rates/useExchangeRatesStore';

export function percentageDiff(start: number, current: number) {
    return trimDecimals(Math.round(((current - start) / start) * 100), 2);
}

export const PRICE_TYPES = ['lastSalePrice', 'listPrice', 'offerPrice'] as const;
type PriceTuple = typeof PRICE_TYPES;
type ComparisonPrice = PriceTuple[number];

// export type ComparisonPrice = 'listPrice' | 'lastSalePrice' | 'offerPrice';
export type ComparisonPriceData = {
    [key in ComparisonPrice]?: { value: string | number; ethValue?: number; usdValue?: number; valueDiff?: number };
};

interface PricingDataArgs {
    floorPriceWei: string | number;
    comparisonPrices?: ComparisonPriceData;
    round?: boolean;
}

export interface PricingDataReturnType {
    ethFloorPriceValue: number;
    usdFloorPrice: number;
    comparisonValues?: ComparisonPriceData;
}
export function getPricingData({
    floorPriceWei,
    comparisonPrices = { listPrice: { value: 0 } },
    round = false,
}: PricingDataArgs): PricingDataReturnType {
    const ethFloorPriceValue = convertWeiToEth(Number(floorPriceWei));
    const comparisonValues = {
        ...comparisonPrices,
    };

    for (const price in comparisonPrices) {
        const ethComparisonPriceValue = convertWeiToEth(Number(comparisonPrices[price].value), 4);
        const usdComparisonFloorPrice = getConversion(Currency.ETH, Currency.USD, ethComparisonPriceValue, round);
        const valueDiff = ethComparisonPriceValue
            ? percentageDiff(ethFloorPriceValue, ethComparisonPriceValue)
            : undefined;
        comparisonValues[price] = {
            ethValue: ethComparisonPriceValue,
            usdValue: usdComparisonFloorPrice,
            valueDiff,
        };
    }
    const usdFloorPrice = getConversion(Currency.ETH, Currency.USD, ethFloorPriceValue, round);

    return {
        ethFloorPriceValue,
        usdFloorPrice,
        comparisonValues,
    };
}
